module.exports = __webpack_public_path__ + "img/34_11.e442c481.png";